import SecurityPolicies from '../security/SecurityPolicies';

export default class SecurityPostPolicies extends SecurityPolicies {
    serviceName = 'Policies/SecurityPostRules';
    reduxId = 'securityPostRules';
    header = 'Security Post Rules';
    recordConfigPath = '$.config.devices.entry.device-group.entry.post-rulebase.security.rules.entry';
}
